export default __webpack_public_path__ + "static/media/symphony-light.f833da00.svg";